export type CJ925TrialItem = {
  productId:number;
  name:string;
  supplierCode:string;
  codeStatus:'verified'|'variant';
  category:'bracelets'|'earrings'|'necklaces'|'rings';
  carat:string;
  shape:string;
  color:string;
  clarity:string;
  certificate:string;
  metal:string;
  variants:string[];
  sourceUrl:string;
  previewImage:string;
  notes?:string;
};

export const CJ925_TRIAL_ITEMS:CJ925TrialItem[]=[
  {
    productId:5802,
    name:'צמיד טניס מוסונייט 4.8 קראט',
    supplierCode:'PJ9B0414',
    codeStatus:'variant',
    category:'bracelets',carat:'4.8 CT',shape:'לא צוין',color:'D',clarity:'VVS1',certificate:'GRA',metal:'כסף 925 + רודיום',
    variants:['אורך — קיימת בחירה באתר המקור'],
    sourceUrl:'https://www.cj925.com/index.php?dispatch=products.view&product_id=5802',
    previewImage:'https://www.cj925.com/images/thumbnails/50/50/detailed/13/PJ9B0414_441g-f7.JPG',
    notes:'במוצר זה קוד יחיד אינו מוצג בדף הציבורי; PJ9B0414 מזוהה כהפניית דגם/תמונה ויש לאשר קוד לכל וריאציית אורך לפני Commit.'
  },
  {
    productId:5801,
    name:'צמיד טניס מוסונייט 2 קראט',
    supplierCode:'PJ9B0414',
    codeStatus:'variant',
    category:'bracelets',carat:'2 CT',shape:'לא צוין',color:'D',clarity:'VVS1',certificate:'GRA',metal:'כסף 925 + רודיום',
    variants:['אורך — קיימת בחירה באתר המקור'],
    sourceUrl:'https://www.cj925.com/index.php?dispatch=products.view&product_id=5801',
    previewImage:'https://www.cj925.com/images/thumbnails/50/50/detailed/13/PJ9B0414.JPG',
    notes:'מוצר עם וריאציית אורך. אין לבצע Commit עד התאמת קוד/מחיר לכל וריאציה.'
  },
  {
    productId:5797,
    name:'עגיל מוסונייט 1.2 קראט',supplierCode:'ME009',codeStatus:'verified',category:'earrings',carat:'1.2 CT',shape:'לא צוין',color:'D',clarity:'VVS1',certificate:'GRA',metal:'כסף 925 + רודיום',variants:[],
    sourceUrl:'https://www.cj925.com/index.php?dispatch=products.view&product_id=5797',previewImage:'https://www.cj925.com/images/thumbnails/50/50/detailed/13/PJ9B9751.JPG'
  },
  {
    productId:5795,
    name:'עגיל מוסונייט 1 קראט לב',supplierCode:'ME006',codeStatus:'verified',category:'earrings',carat:'1 CT',shape:'לב',color:'D',clarity:'VVS1',certificate:'GRA',metal:'כסף 925 + רודיום',variants:[],
    sourceUrl:'https://www.cj925.com/index.php?dispatch=products.view&product_id=5795',previewImage:'https://www.cj925.com/images/thumbnails/50/50/detailed/13/PJ9B9764.JPG'
  },
  {
    productId:5794,
    name:'עגיל מוסונייט 1 קראט סוליטר טיפה',supplierCode:'ME005',codeStatus:'verified',category:'earrings',carat:'1 CT',shape:'טיפה',color:'D',clarity:'VVS1',certificate:'GRA',metal:'כסף 925 + רודיום',variants:[],
    sourceUrl:'https://www.cj925.com/index.php?dispatch=products.view&product_id=5794',previewImage:'https://www.cj925.com/images/thumbnails/50/50/detailed/13/PJ9B9756.JPG'
  },
  {
    productId:5792,
    name:'שרשרת מוסונייט 0.5 קראט לב',supplierCode:'MN012',codeStatus:'verified',category:'necklaces',carat:'0.5 CT',shape:'לב',color:'D',clarity:'VVS1',certificate:'GRA',metal:'כסף 925 + רודיום',variants:[],
    sourceUrl:'https://www.cj925.com/index.php?dispatch=products.view&product_id=5792',previewImage:'https://www.cj925.com/images/thumbnails/50/50/detailed/13/PJ9B9773.JPG'
  },
  {
    productId:5787,
    name:'שרשרת מוסונייט 2 קראט טיפה',supplierCode:'MN008',codeStatus:'verified',category:'necklaces',carat:'2 CT',shape:'טיפה',color:'D',clarity:'VVS1',certificate:'GRA',metal:'כסף 925 + רודיום',variants:[],
    sourceUrl:'https://www.cj925.com/index.php?dispatch=products.view&product_id=5787',previewImage:'https://www.cj925.com/images/thumbnails/50/50/detailed/13/PJ9B9771.JPG'
  },
  {
    productId:5771,
    name:'טבעת מוסונייט 1 קראט',supplierCode:'MR010_94E9',codeStatus:'verified',category:'rings',carat:'1 CT',shape:'לא צוין',color:'D',clarity:'VVS1',certificate:'GRA',metal:'כסף 925 + רודיום',variants:['US 5','US 6','US 7','US 8','US 9'],
    sourceUrl:'https://www.cj925.com/index.php?dispatch=products.view&product_id=5771',previewImage:'https://www.cj925.com/images/thumbnails/50/50/detailed/13/PJ9B9395_n03g-g0.JPG',
    notes:'תמונת ה-Preview היא תמונת לייף-סטייל משנית מהדף. בשלב המדיה נוריד את תמונת המוצר הראשית באיכות מלאה.'
  },
  {
    productId:5761,
    name:'טבעת מוסונייט טיפה 1.5 קראט',supplierCode:'MR008_4114',codeStatus:'verified',category:'rings',carat:'1.5 CT',shape:'טיפה',color:'D',clarity:'VVS1',certificate:'GRA',metal:'כסף 925 + רודיום',variants:['US 5','US 6','US 7','US 8','US 9'],
    sourceUrl:'https://www.cj925.com/index.php?dispatch=products.view&product_id=5761',previewImage:'https://www.cj925.com/images/thumbnails/50/50/detailed/13/PJ9B9078.JPG'
  },
  {
    productId:5735,
    name:'טבעת מוסונייט סוליטר מרובע 1 קראט',supplierCode:'MR003',codeStatus:'verified',category:'rings',carat:'1 CT',shape:'מרובע',color:'D',clarity:'VVS1',certificate:'GRA',metal:'כסף 925 + רודיום',variants:['US 5','US 6','US 7','US 8','US 9'],
    sourceUrl:'https://www.cj925.com/index.php?dispatch=products.view&product_id=5735',previewImage:'https://www.cj925.com/images/thumbnails/50/50/detailed/13/PJ9B9071.JPG'
  }
];
